import {
  ICreateWorkspaceDto,
  IWorkspaceDetailsDto,
  WorkspaceStatus,
} from 'types';

export type WorkspaceFormFields = Omit<
  ICreateWorkspaceDto,
  'startDate' | 'endDate' | 'owners'
> & {
  durationStart: Date;
  durationEnd: Date;
  status?: WorkspaceStatus;
};

export type WorkspaceFormProps = {
  disabled?: boolean;
  isLoading?: boolean;
} & (
  | {
      mode: WorkspaceFormMode.CREATE;
    }
  | {
      mode: WorkspaceFormMode.EDIT;
      initialValues: IWorkspaceDetailsDto;
    }
);

export enum WorkspaceFormMode {
  CREATE = 'create',
  EDIT = 'edit',
}
